import React from "react";
import { getChartDiaAsync } from "../../../api/Dashboard";
import BarrasPorGestor from "./BarrasPorGestor";

// Lo cobrado hoy por cada gestor: ingreso, en el color de éxito.
const ChartDia = () => (
  <BarrasPorGestor
    titulo="Recuperación diaria por gestor"
    obtener={getChartDiaAsync}
    color="exito"
    descripcionVacio="Aquí se muestra lo cobrado hoy por cada gestor."
  />
);

export default ChartDia;
